// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wiggleCart":"tUcFj","shake":"ch4aP"};